import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useHistory } from 'react-router-dom';
import useQueryString from '../../../hooks/use-query-string';
import { routes } from '../../../routes';
import { CustomerContext } from '../../../contexts/CustomerContext';
import useBreakpoints from '../../../hooks/use-breakpoints';
// import desktopHomePageImg from '../../../assets/desktop-home-page.jpg';
import desktopHomePageImg from '../../../assets/Home-Page_Header.jpg';
import mobileHomePageImg from '../../../assets/mobile-home-page.png';
import categoryFallImg from '../../../assets/Category_Fall.png';
import categoryPanoramasImg from '../../../assets/Category_Panoramas.png';
import categorySeniorsImg from '../../../assets/Category_Seniors.png';
import categorySportsImg from '../../../assets/Category_Sports.png';
import categoryYearbookImg from '../../../assets/Category_Yearbook.png';
import resourcesStockImg from '../../../assets/resources_stock_image.jpg';
import resourcesSamplesImg from '../../../assets/school_resources_samples.webp';
import yearbooksStockImg from '../../../assets/yearbooks_stock_image.jpg';
import styles from './Home.module.scss';

const HomePage = () => {
  const history = useHistory();
  const { app } = useQueryString();
  const { customer } = useContext(CustomerContext);
  const breakpoint = useBreakpoints();

  localStorage.setItem('isUsingAccessCode', false);

  useEffect(() => {
    if (!app) return;

    if (app && !customer.apptCart) history.push(routes.home());
  }, [app]);

  if (breakpoint === '') return null;

  const homePageImg = ['sm'].includes(breakpoint) ? mobileHomePageImg : desktopHomePageImg;

  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Helmet>
      <Link to={routes.studentIdEntry()}>
        <img alt="Home Page" className={styles.banner} src={homePageImg} />
      </Link>
      <div className={styles.categoriesContainer}>
        <h3 className={styles.categoriesHeader}>CHOOSE A CATEGORY TO ORDER</h3>
        <div className={styles.categoryLinksContainer}>
          <div className={styles.linkContainer}>
            <Link to={routes.studentIdEntry({ order: 'yearbook_order' })}>
              <img alt="Yearbook" className={styles.categoryImg} src={categoryYearbookImg} />
              <br />
              <br />
              Yearbooks
            </Link>
          </div>
          <div className={styles.linkContainer}>
            <Link to={routes.studentIdEntry()}>
              <img alt="Fall" className={styles.categoryImg} src={categoryFallImg} />
              <br />
              <br />
              School Pictures
            </Link>
          </div>
          <div className={styles.linkContainer}>
            <Link to={routes.studentIdEntry({ order: 'senior' })}>
              <img alt="Seniors" className={styles.categoryImg} src={categorySeniorsImg} />
              <br />
              <br />
              Senior Portraits
            </Link>
          </div>
          <div className={styles.linkContainer}>
            <Link to={routes.studentIdEntry({ order: 'sport' })}>
              <img alt="Sports" className={styles.categoryImg} src={categorySportsImg} />
              <br />
              <br />
              Sports & Teams
            </Link>
          </div>
          <div className={styles.linkContainer}>
            <Link to={routes.studentIdEntry({ order: 'panorama' })}>
              <img alt="Panoramas" className={styles.categoryImg} src={categoryPanoramasImg} />
              <br />
              <br />
              Panoramas & Groups
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.resourcesPromoContainer}>
        <div className={styles.resourcesPromoTextContainer}>
          <h3 className={styles.resourcesHeader}>
            We support your
            <br />
            school beyond
            <br />
            Picture Day
            <br />
          </h3>
          <br />
          <p className={styles.resourcesText}>
            From attendance to positive
            <br />
            behavior support, Shoob
            <br />
            Photography offers <b style={{ fontWeight: 700 }}>FREE</b> resources
            <br />
            to support education at every level.
            <br />
          </p>
          <br />
          <a href="/school_resources" className={`btn btn-default btn-lg ${styles.resourcesBtn}`}>
            View Resources
          </a>
        </div>
        <div className={styles.resourcesImgContainer}>
          <img alt="School Resources" className={styles.resourcesStockImg} src={resourcesStockImg} />
          <img alt="School Resources Samples" className={styles.resourcesSamplesImg} src={resourcesSamplesImg} />
        </div>
      </div>
      <div className={styles.yearbooksPromoContainer}>
        <div className={styles.yearbooksImgContainer}>
          <img alt="Yearbooks" className={styles.yearbooksStockImg} src={yearbooksStockImg} />
          <img alt="Yearbooks Samples" className={styles.yearbooksSamplesImg} src={categoryYearbookImg} />
        </div>
        <div className={styles.yearbooksPromoTextContainer}>
          <h3 className={styles.yearbooksHeader}>
            Make memories
            <br />
            shine with
            <br />
            <b style={{ fontWeight: 700 }}>Shoob Yearbooks</b>
          </h3>
          <br />
          <p className={styles.yearbooksText}>
            Use Canva to create your yearbook!
            <br />
            No paper order forms - families order online!
            <br />
            Books printed and delivered directly to you
          </p>
          <br />
          <a href="/yearbook_requests/new" className={`btn btn-default btn-lg ${styles.yearbooksBtn}`}>Learn More</a>
        </div>
      </div>
      <footer>
        <div className="container">
          <div className="row">
            <div className={`col-xs-12 col-sm-7 ${styles.footerSection} ${styles.footerLeftSection}`}>
              <p className={styles.footerHeader}>Contact Us</p>
              <p className={styles.footerSubheader}>Email Address</p>
              <p className={styles.footerText}>
                <a href="mailto:info@shoobphoto.com">info@shoobphoto.com</a>
              </p>
              <p className={styles.footerSubheader}>Phone Number</p>
              <p className={styles.footerText}>(209) 567-0748</p>
              <p className={styles.footerSubheader}>Business Hours</p>
              <p className={styles.footerText}>Monday-Friday 8am-5pm</p>
              <p className={styles.footerText} style={{ marginTop: '1rem' }}>4640 Spyres Way, Suite 1</p>
              <p className={styles.footerText}>Modesto, CA 95356</p>
            </div>
            <div className={`col-xs-12 col-sm-5 ${styles.footerSection}`}>
              <p className={styles.footerHeader}>For Schools</p>
              <p className={styles.footerText}>
                <a href="../school_resources/request_form_info">Book a Picture Day</a>
              </p>
              <p className={styles.footerText}>
                <a href="/school_resources">Resources for Schools Catalog</a>
              </p>
              {/* <p className={styles.footerText}> */}
              {/* <a href="">Shoob Staff Directory</a> */}
              {/* </p> */}
              <br />
              <p className={styles.footerHeader}>For Parents</p>
              <p className={styles.footerText}>
                <Link to={routes.registration()}>
                  Sign up for Picture Day Notifications
                </Link>
              </p>
              {/* <a href="">Check Order Status</a> */}
              <p className={styles.footerText}>
                <Link to={routes.frequentlyAskedQuestions()}>FAQ</Link>
              </p>
              <br />
              <p className={styles.footerText}>
                <a href='/privacy-policy'>Privacy Policy</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
